import { DetailSession } from '@streem/sdk-core';
import { useObservable } from '@streem/sdk-react';
import { TranscriptBlock } from '../util/convert_transcription_segments_to_blocks';
import { IndexChangedCallback, useTranscriptionContext } from './use_transcription_context';
import { ChangeEvent } from 'react';

interface ReturnVal {
    transcriptBlocks: TranscriptBlock[];
    transcriptionsInitialized: boolean;
    transcriptionError: Error | undefined;
    refresh: () => Promise<void>;
    registerIndexChangedCallback: (cb: IndexChangedCallback) => void;
    unregisterIndexChangedCallback: (cb: IndexChangedCallback) => void;
    autoScrollModeActive: boolean;
    handleTimeStampJump: (time: number) => void;
    handleSearch: (e: ChangeEvent<HTMLInputElement>) => void;
    searchValue: string;
    clearSearch: () => void;
    updateAutoScrollMode: (mode: boolean) => void;
}

export function useTranscriptions(detailSession: DetailSession): ReturnVal {
    const [transcriptionsInitialized = false] = useObservable(
        detailSession.transcriptionController.initialized,
    );
    const {
        transcriptBlocks,
        registerIndexChangedCallback,
        unregisterIndexChangedCallback,
        autoScrollModeActive,
        handleTimeStampJump,
        handleSearch,
        searchValue,
        clearSearch,
        updateAutoScrollMode,
    } = useTranscriptionContext();
    const [error = undefined] = useObservable(detailSession.transcriptionController.error);

    return {
        transcriptBlocks,
        transcriptionsInitialized,
        transcriptionError: error,
        refresh: detailSession.transcriptionController.refresh,
        registerIndexChangedCallback,
        unregisterIndexChangedCallback,
        autoScrollModeActive,
        handleTimeStampJump,
        handleSearch,
        searchValue,
        clearSearch,
        updateAutoScrollMode,
    };
}
